import AccountingApi from '../../../api/accounting/accounting';

export default {
  namespaced: true,
  states: {

  },
  mutations: {

  },
  actions: {
    async create({ dispatch }, { form }) {
      try {
        const response = await AccountingApi.create(form);
        return Promise.resolve(response.data);
      } catch(e) {
        await dispatch('NOTIFY_ERROR', e, {root: true});
        return Promise.reject(e);
      }
    },
    async get({ dispatch }, { financeId }) {
      try {
        const response = await AccountingApi.get(financeId);
        return Promise.resolve(response.data);
      } catch(e) {
        await dispatch('NOTIFY_ERROR', e, {root: true});
        return Promise.reject(e);
      }
    },
    async getBookingAccount({ dispatch }, { context, id }) {
      try {
        const response = await AccountingApi.getBookingAccount(context, id);
        return Promise.resolve(response.data);
      } catch(e) {
        await dispatch('NOTIFY_ERROR', e, {root: true});
        return Promise.reject(e);
      }
    },
    async getBookingAccounts({ dispatch }) {
      try {
        const response = await AccountingApi.getBookingAccounts();
        return Promise.resolve(response.data);
      } catch(e) {
        await dispatch('NOTIFY_ERROR', e, {root: true});
        return Promise.reject(e);
      }
    },
    async upsertBookingAccount({ dispatch }, form) {
      try {
        await AccountingApi.upsertBookingAccount(form);
        dispatch('NOTIFY_MSG', 'accounting.notification.updateBookingAccount',
          { root: true});
        return Promise.resolve();
      } catch(e) {
        await dispatch('NOTIFY_ERROR', e, {root: true});
        return Promise.reject(e);
      }
    },
    async updateBookingAccount({ dispatch }, form) {
      try {
        const response = await AccountingApi.updateBookingAccount(form);
        dispatch('NOTIFY_MSG', 'accounting.notification.updateBookingAccount',
          { root: true});
        return Promise.resolve(response.data);
      } catch(e) {
        await dispatch('NOTIFY_ERROR', e, {root: true});
        return Promise.reject(e);
      }
    }
  }
}
